import getDistanceFromLatLngInKm from './getDistanceFromLatLngInKm'

const findClosestMarkers = (allMarkers, searchLatLng) => {
    const minDistanceForNearestDealers = 75;
    let markersArray = []
    let closestMarker = {}
    let shortestDistance = null

    allMarkers.forEach(marker => {
        if (marker.latitude === null || marker.longitude === null) return

        const distanceFromSearch = getDistanceFromLatLngInKm(searchLatLng.latitude, searchLatLng.longitude, marker.latitude, marker.longitude)

        if (distanceFromSearch < shortestDistance || shortestDistance === null) {
            closestMarker = marker
            marker.distance = distanceFromSearch
            shortestDistance = distanceFromSearch
        }

        if (distanceFromSearch <= minDistanceForNearestDealers) {
            marker.distance = distanceFromSearch
            markersArray.push(marker);
        }
    })

    if (markersArray.length === 0) {
        markersArray.push(closestMarker)
    }

    return markersArray
}

export default findClosestMarkers